import React from 'react';
import { useTheme } from 'styled-components';

export const EmailSvg = (props) => {

  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "14"} height={height ?? "12"} viewBox="0 0 14 12" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.95933 0C10.8533 0 11.7133 0.353333 12.346 0.987333C12.9793 1.62 13.3333 2.47333 13.3333 3.36667V8.63333C13.3333 10.4933 11.82 12 9.95933 12H3.37333C1.51267 12 0 10.4933 0 8.63333V3.36667C0 1.50667 1.506 0 3.37333 0H9.95933ZM11.0203 4.36006L11.0737 4.30673C11.233 4.1134 11.233 3.8334 11.0663 3.64006C10.9737 3.54073 10.8463 3.48006 10.7137 3.46673C10.5737 3.4594 10.4403 3.50673 10.3397 3.60006L7.33366 6.00006C6.947 6.32073 6.393 6.32073 6.00033 6.00006L3.00033 3.60006C2.793 3.44673 2.50633 3.46673 2.33366 3.64673C2.15366 3.82673 2.13366 4.1134 2.28633 4.3134L2.37366 4.40006L5.407 6.76673C5.78033 7.06006 6.233 7.22006 6.707 7.22006C7.17966 7.22006 7.64033 7.06006 8.013 6.76673L11.0203 4.36006Z" />
    </svg>
  )
}